import { FormInputType } from '@/constants/form/FormInputType.js'
import config from '@/common/config'

export default {
  data() {
    return {
      rules: {},
      passwordRegexString: config.get('app.password.allowedCharsRegex'),
      passwordMinChars: config.get('app.password.minChars'),
    }
  },
  created() {
    this.initRules()
  },
  computed: {
    formInputType() {
      return FormInputType
    },
  },
  methods: {
    initRules() {
      this.rules = {
        required: this.requiredRule,
        email: this.emailRule,
        passwordMinCharacters: this.passwordMinRule,
        uppercase: this.uppercaseRule,
        lowercase: this.lowercaseRule,
        number: this.numberRule,
        passwordsMatch: this.passwordMatchRule,
        special: this.specialCharacterRule,
        validPercent: this.validPercentRule,
        integer: this.integerRule,
        positiveNumber: this.positiveNumberRule,
        validInt32: this.validInt32Rule,
      }
    },
    requiredRule(v) {
      if (typeof v === 'string') {
        const trimmedString = v.replace(/^\s+|\s+$/gm, '')
        return !!trimmedString || this.$t('input.inputRequiredValidationText')
      }
      return !!v || this.$t('input.inputRequiredValidationText')
    },
    emailRule(v) {
      return /.+@.+/.test(v) || this.$t('input.emailRequiredValidationText')
    },
    passwordMinRule(v) {
      return (
        (!!v && v.length >= this.passwordMinChars) ||
        this.$t('input.passwordRuleMinCharacters', {
          min: this.passwordMinChars,
        })
      )
    },
    uppercaseRule(v) {
      return (
        (!!v && v.toLowerCase() !== v) || this.$t('input.passwordRuleUpperCase')
      )
    },
    lowercaseRule(v) {
      return (
        (!!v && v.toUpperCase() !== v) || this.$t('input.passwordRuleLowerCase')
      )
    },
    numberRule(v) {
      return (!!v && /\d/.test(v)) || this.$t('input.passwordRuleNumber')
    },
    passwordMatchRule(v) {
      return (
        (!!v && v === this.newPass) || this.$t('input.passwordRuleMustMatch')
      )
    },
    specialCharacterRule(v) {
      const allowedCharsRegex = new RegExp(this.passwordRegexString, 'g')

      return (
        (!!v && allowedCharsRegex.test(v)) ||
        this.$t('input.passwordRuleSpecialCharacter')
      )
    },
    passwordCriteriaMet(password) {
      return (
        this.requiredRule(password) === true &&
        this.uppercaseRule(password) === true &&
        this.lowercaseRule(password) === true &&
        this.numberRule(password) === true &&
        this.specialCharacterRule(password) === true &&
        this.passwordMinRule(password) === true
      )
    },
    integerRule(v) {
      return (
        (!isNaN(v) && Number.isInteger(Number(v))) ||
        this.$t('input.integerValidationText')
      )
    },
    validInt32Rule(v) {
      const MIN_INT32 = -2147483648
      const MAX_INT32 = 2147483647

      return (
        (!isNaN(v) &&
          Number.isInteger(Number(v)) &&
          v >= MIN_INT32 &&
          v <= MAX_INT32) ||
        this.$t('input.int32ValidationText')
      )
    },
    validPercentRule(v) {
      return (
        (!isNaN(v) && Number(v) > 0 && Number(v) <= 100) ||
        this.$t('input.percentValidationText')
      )
    },
    positiveNumberRule(v) {
      return (
        (!isNaN(v) && v > 0) || this.$t('input.positiveNumberValidationText')
      )
    },
  },
}
